import { render, staticRenderFns } from "./LIZYDZQQ.vue?vue&type=template&id=f5e73662&scoped=true"
import script from "./LIZYDZQQ.vue?vue&type=script&lang=js"
export * from "./LIZYDZQQ.vue?vue&type=script&lang=js"
import style0 from "./LIZYDZQQ.vue?vue&type=style&index=0&id=f5e73662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e73662",
  null
  
)

export default component.exports